export const UPLOAD_DOCS_GUIDELINES = [
    'Hover over the document list to view samples and download templates',
    'Read the upload instructions carefully before uploading the documents.',
]

export const UPLOAD_INSTRUCTIONS = [
    'Ensure the document is clear, properly aligned, and not tilted.',
    'Accepted file formats: PNG, JPG, JPEG, PDF.',
    'Maximum file size: 5MB.',
]

export const NON_OCR_DOCS = [
    'ayurvedic_license',
    'fssai_license',
    'bis_license',
    'additional_document_1',
    'additional_document_2',
    'additional_document_3',
    'ubo_certificate',
]

export const additionalDocumentsByCategory = {
    'Beauty accessories': ['Ayurvedic License'],
    Ecommerce: ['FSSAI License', 'Ayurvedic License'],
    FMCG: ['FSSAI License', 'Ayurvedic License'],
    'Food and Beverages (Fastfood)': ['FSSAI License', 'Ayurvedic License'],
    Grocery: ['FSSAI License', 'Ayurvedic License'],
    Healthcare: ['FSSAI License', 'Ayurvedic License'],
    Jewellery: ['BIS Certificate', 'Ayurvedic License'],
    'Wholesale Trade and B2B': ['FSSAI License', 'Ayurvedic License', 'BIS Certificate'],
    Marketplace: ['FSSAI License', 'Ayurvedic License', 'BIS Certificate'],
    'Departmental store and ecom': ['FSSAI License', 'Ayurvedic License', 'BIS Certificate'],
    Others: ['FSSAI License', 'Ayurvedic License', 'BIS Certificate'],
}

export const documentToQuestion = {
    'FSSAI License': 'Do You Sell Edible Food Products?',
    'Ayurvedic License': 'Do You Sell Ayurvedic Products?',
    'BIS Certificate': 'Do You Sell Gold and Silver Products?',
}
